import * as React from "react"
import { Box } from "@mui/material"

import { NotAllowedBlock } from "@components"


export default function daysOutStockColumn() {
	return {
		name: 'lastOutOfStockDays', label: 'Days since last out of stock',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'wrap', maxWidth: 50 }
			}),
			customBodyRowRender: (value, row) => <Box sx={{
				color: !!row.stock && value !== 0  ? 'text.primary' : 'text.disabled',
				textAlign: 'center'
			}}>
				{ value === null ? <NotAllowedBlock /> : value}
			</Box>
		}
	}
}